import script from "./payanother.vue?vue&type=script&setup=true&lang=js"
export * from "./payanother.vue?vue&type=script&setup=true&lang=js"

import "./payanother.vue?vue&type=style&index=0&id=65ee58e4&lang=less&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-65ee58e4"]])

export default __exports__